import { createFileRoute } from "@tanstack/react-router";
import { StorageOverview } from "@/components/views";
import type { RouterAppContext } from "@/utils/custom-types";

export const Route = createFileRoute("/$workspaceId/storage/")({
	component: RouteComponent,
});

function RouteComponent() {
	const { workspaceId } = Route.useParams();
	const { session, currentWorkspace } =
		Route.useRouteContext() as RouterAppContext;
	
	return (
		<StorageOverview
			workspaceId={workspaceId}
			session={session}
			currentWorkspace={currentWorkspace}
		/>
	);
}